module.exports = __webpack_public_path__ + "img/appy@2x.85501211.png";